import React from 'react';
import { Link } from 'react-router';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { I18N } from '../../../../constants';
import SmallLoader from '../../../../components/SmallLoader';
import { formatDate } from '../../../../shared/utils/date';

const runCodeFormatter = (cell, row) => <Link to={`runs/${row.runId}`}>{row.routeCode}</Link>;

class LostTrackingTable extends React.Component {
    render() {
        const { data, isFetching } = this.props;

        const options = {
            defaultSortName: 'runDate',
            defaultSortOrder: 'asc',
            noDataText: isFetching ? (
                <SmallLoader />
            ) : (
                'No data to display. Please refine your search.'
            ),
        };

        return (
            <BootstrapTable data={data} options={options} pagination striped hover maxHeight={500}>
                <TableHeaderColumn
                    isKey
                    dataField="routeCode"
                    dataFormat={runCodeFormatter}
                    dataSort
                    filter={{ type: 'TextFilter' }}
                >
                    Run
                </TableHeaderColumn>
                <TableHeaderColumn
                    dataField="runDate"
                    dataFormat={formatDate}
                    dataSort
                    filter={{ type: 'DateFilter' }}
                >
                    Run date
                </TableHeaderColumn>
                <TableHeaderColumn
                    dataField="runStatus"
                    dataSort
                    filter={{
                        type: 'SelectFilter',
                        options: I18N.RUN_STATUS,
                    }}
                >
                    Status
                </TableHeaderColumn>
            </BootstrapTable>
        );
    }
}

export default LostTrackingTable;
